/**
 * Standalone deploy: set VITE_CYCLES_API_URL at build time to your Python API origin
 * (e.g. https://api.cycles.social) — no trailing slash.
 * Leave unset in local dev to use Vite proxy paths (/api, /oauth).
 */
export function getCyclesApiOrigin() {
  const raw = import.meta.env.VITE_CYCLES_API_URL;
  if (raw == null || String(raw).trim() === '') return '';
  return String(raw).replace(/\/+$/, '');
}

export function getSyncApiOrigin() {
  const raw = import.meta.env.VITE_SYNC_API_URL || import.meta.env.VITE_CYCLES_API_URL;
  if (raw == null || String(raw).trim() === '') return '';
  return String(raw).replace(/\/+$/, '');
}

export function getWcsRuntimeOrigin() {
  const raw = import.meta.env.VITE_WCS_RUNTIME_URL;
  if (raw == null || String(raw).trim() === '') return '';
  return String(raw).replace(/\/+$/, '');
}

/** Absolute API URL for a path starting with / */
export function apiUrl(path) {
  const p = path.startsWith('/') ? path : `/${path}`;
  const o = getCyclesApiOrigin();
  return o ? `${o}${p}` : p;
}

/** Absolute runtime URL for a path starting with / */
export function runtimeUrl(path) {
  const p = path.startsWith('/') ? path : `/${path}`;
  const o = getWcsRuntimeOrigin();
  return o ? `${o}${p}` : p;
}
